// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__2JeB5","fadeIn":"Overlay_fadeIn__8WlFL","fadeOut":"Overlay_fadeOut__oY1nf"};